import script from "./BaseTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&setup=true&lang=js"

import "./BaseTextarea.vue?vue&type=style&index=0&id=56bf2d7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bf2d7a"]])

export default __exports__